// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3dfa8357","977":"7eee8b3f"}[chunkId] + ".chunk.js";
};